import { ADD_TEMPLATE, ADD_TEMPLATE_FAILED, ADD_TEMPLATE_SUCCESS, DELETE_TEMPLATE, DELETE_TEMPLATE_FAILED, 
    DELETE_TEMPLATE_SUCCESS, EDIT_TEMPLATE, EDIT_TEMPLATE_FAILED, EDIT_TEMPLATE_SUCCESS, GET_TEMPLATE, GET_TEMPLATE_FAILED,
     GET_TEMPLATE_SUCCESS, TEMPLATE_DETAILS, TEMPLATE_DETAILS_FAILED, TEMPLATE_DETAILS_SUCCESS, TEMPLATE_PREVIEW,
      TEMPLATE_PREVIEW_FAILED, TEMPLATE_PREVIEW_SUCCESS, GET_TEMPLATE_DATA,GET_TEMPLATE_DATA_SUCCESS,GET_TEMPLATE_DATA_FAIL } from "./actionTypes"

const initialState = {

    loading: false,
    previewLoading: false,
    templateListSuccess: null,
    templateListFailed: null,
    templateAddSuccess: null,
    templateAddFailed: null,
    templateEditSuccess: null,
    templateEditFailed: null,
    detail: null,
    detailFailed: null,
    deleteSuccess: null,
    deleteFailed: null,
    previewSuccess: null,
    previewFailed: null,





}

const getTemplateConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case TEMPLATE_DETAILS: {
            state = {
                ...state,
                loading: true,
                templateListSuccess: null,
                templateListFailed: null
            }
            break;

        }
        case TEMPLATE_DETAILS_SUCCESS: {
            state = {
                ...state,
                loading: false,
                templateListSuccess: action.payload,
                templateListFailed: null
            }
            break;

        }
        case TEMPLATE_DETAILS_FAILED: {
            state = {
                ...state,
                loading: false,
                templateListSuccess: null,
                templateListFailed: action.payload
            }
            break;
        }
        case ADD_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                templateAddSuccess: null,
                templateAddFailed: null
            }
            break;

        }
        case ADD_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                templateAddSuccess: action.payload,
                templateAddFailed: null
            }
            break;

        }
        case ADD_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                templateAddSuccess: null,
                templateAddFailed: action.payload
            }
            break;
        }
        case EDIT_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                templateEditSuccess: null,
                templateEditFailed: null
            }
            break;

        }
        case EDIT_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                templateEditSuccess: action.payload,
                templateEditFailed: null
            }
            break;

        }
        case EDIT_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                templateEditSuccess: null,
                templateEditFailed: action.payload
            }
            break;

        }
        case GET_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                detail: null,
                detailFailed: null
            }
            break;

        }
        case GET_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                detail: action.payload,
                detailFailed: null
            }
            break;

        }
        case GET_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                detail: null,
                detailFailed: action.payload
            }
            break;
        }
        case DELETE_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                deleteSuccess: null,
                deleteFailed: null,
            }
            break;

        }
        case DELETE_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                deleteSuccess: action.payload,
                deleteFailed: null,
            }
            break;

        }
        case DELETE_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                deleteSuccess: null,
                deleteFailed: action.payload,
            }
            break;
        }
        case TEMPLATE_PREVIEW: {
            state = {
                ...state,
                previewLoading: true,
                previewSuccess: null,
                previewFailed: null,
            }
            break;

        }
        case TEMPLATE_PREVIEW_SUCCESS: {
            state = {
                ...state,
                previewLoading: false,
                previewSuccess: action.payload,
                previewFailed: null,
            }
            break;

        }
        case TEMPLATE_PREVIEW_FAILED: {
            state = {
                ...state,
                previewLoading: false,
                previewSuccess: null,
                previewFailed: action.payload,
            }
            break;
        }
        case GET_TEMPLATE_DATA: {
            state = {
                ...state,
                loading: true,
                templateData: null,
            }
            break;
        }
        case GET_TEMPLATE_DATA_SUCCESS: {
            state = {
                ...state,
                loading: false,
                templateData: action.payload
            }
            break;
        }

        case GET_TEMPLATE_DATA_FAIL: {
            state = {
                ...state,
                loading: false,
                templateData: null
            }
            break;
        }

        default:
            state = { ...state }
            break
    }
    return state
}

export default getTemplateConfiguration
